import React, { useEffect } from 'react';
import { Button, Dropdown } from 'antd';
import { ArrowDownIcon, CheckCircleIcon } from 'icons';
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';

import { IUniversitySort } from 'modules/universities';

interface IProps {
  sortUniversity?: IUniversitySort[];
}

const FilterSectionDropdown: React.FC<IProps> = ({ sortUniversity = [] }) => {
  const yearOptions = sortUniversity.map(item => ({
    label: item.year,
    value: item.year
  }));

  const languageSet = new Set<string>();
  const studySet = new Set<string>();

  sortUniversity.forEach(item => {
    item.languages.forEach(lang => languageSet.add(lang));
    item.studies.forEach(study => studySet.add(study));
  });

  const languageOptions = Array.from(languageSet).map(lang => ({
    label: lang,
    value: lang
  }));

  const typeOptions = Array.from(studySet).map(study => ({
    label: study,
    value: study
  }));

  const [query, setQuery] = useQueryParams({
    year: withDefault(NumberParam, yearOptions[0]?.value),
    language: withDefault(StringParam, languageOptions[0]?.value),
    study: withDefault(StringParam, typeOptions[0]?.value)
  });

  const defaultYear = yearOptions[0]?.value;
  const defaultLanguage = languageOptions[0]?.value;
  const defaultStudy = typeOptions[0]?.value;

  useEffect(() => {
    if (!query.year || !query.language || !query.study) {
      setQuery(
        {
          year: query.year ?? defaultYear,
          language: query.language ?? defaultLanguage,
          study: query.study ?? defaultStudy
        },
        'replace'
      );
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query, defaultYear, defaultLanguage, defaultStudy]);

//   const handleMenuClick = (key: string, value: any) => {
//     setQuery({ ...query, [key]: value });
//   };

  //   const createMenu = (key: string, options: { label: string | number; value: any }[]): MenuProps => ({
  //     items: options.map(option => ({
  //       key: option.value,
  //       label: option.label,
  //       onClick: () => handleMenuClick(key, option.value)
  //     }))
  //   });

  const generateMenu = (key: 'year' | 'language' | 'study', options: { label: string | number; value: any }[]) => ({
    items: options.map(option => ({
      key: option.value.toString(),
      label: (
        <div className="flex items-center justify-between">
          {option.label}
          {option.value === query[key] && <CheckCircleIcon size="18" />}
        </div>
      ),
      onClick: () => setQuery({ ...query, [key]: option.value })
    }))
  });

  return (
    <div className="hidden gap-3 sm:flex md:hidden">
      <div>
        <Dropdown dropdownRender={menu => <div className="w-40">{menu}</div>} placement="bottomLeft" className="!rounded-xl" menu={generateMenu('year', yearOptions)}>
          <Button className="flex w-full justify-between">
            {query.year} <ArrowDownIcon />
          </Button>
        </Dropdown>
      </div>

      <div>
        <Dropdown dropdownRender={menu => <div className="w-40">{menu}</div>} placement="bottomLeft" className="!rounded-xl" menu={generateMenu('language', languageOptions)}>
          <Button className="flex w-full justify-between">
            {query.language} <ArrowDownIcon />
          </Button>
        </Dropdown>
      </div>

      <div>
        <Dropdown dropdownRender={menu => <div className="w-40">{menu}</div>} placement="bottomLeft" className="!rounded-xl" menu={generateMenu('study', typeOptions)}>
          <Button className="flex w-full justify-between">
            {query.study} <ArrowDownIcon />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

export default FilterSectionDropdown;
